/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UploadBrandLogoImageRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {UploadBrandLogoImageResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const uploadBrandLogoImage = (request: UploadBrandLogoImageRequest, options?: CashRequestOptions) => post<UploadBrandLogoImageRequest, UploadBrandLogoImageResponse>("/2.0/cash/upload-brand-logo-image", request, {...options, rejectOnError: true })